module.exports = __webpack_public_path__ + "img/Maibaum.fb2f916e.jpg";